var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "table-container-avaialble-butterfly-items" },
      [
        _c(
          "bulma-table",
          {
            staticClass: "table is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "has-sticky-header": true,
              "page-index": _vm.filter.pageIndex,
              "page-size": _vm.filter.pageSize,
              "total-rows": _vm.totalRows,
              "is-loading": _vm.isTableLoading,
              "sort-column": _vm.filter.sortColumn,
              "sort-order": _vm.filter.sortOrder,
              draggable: false,
            },
            on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
          },
          [
            _vm._l(_vm.pagedActiveItems, function (item, index) {
              return _c(
                "tr",
                {
                  key: item.quoteItemId,
                  class: { "is-selected": _vm.selectedRow === index },
                  on: {
                    dblclick: function ($event) {
                      return _vm.addNewItem(item, index)
                    },
                  },
                },
                [
                  _c("td", { staticClass: "itemno-input" }, [
                    _vm._v(_vm._s(item.itemNo)),
                  ]),
                  _c("td", [_vm._v(_vm._s(item.itemDesc))]),
                  _c(
                    "td",
                    { staticClass: "has-vertical-middle has-text-centered" },
                    [
                      _c("span", { staticClass: "icon has-text-info" }, [
                        _c("i", {
                          staticClass: "mdi mdi-24px",
                          class: [item.reportOnly ? "mdi-check" : ""],
                        }),
                      ]),
                    ]
                  ),
                  _c(
                    "td",
                    { staticClass: "has-vertical-middle has-text-centered" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "tag",
                          class: _vm.sideTagClass(item.side),
                        },
                        [_vm._v(_vm._s(item.side))]
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "has-vertical-middle has-text-centered is-content-width",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$filters.formatPartType(item.mark)) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    { staticClass: "has-vertical-middle has-text-right" },
                    [_vm._v(_vm._s(item.itemQuantity))]
                  ),
                  _c(
                    "td",
                    { staticClass: "has-vertical-middle has-text-right" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatNumber(
                            item.value,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    { staticClass: "has-vertical-middle has-text-right" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatNumber(
                            item.markupValue,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]
                  ),
                  _c("td", { staticClass: "partno-input" }, [
                    _vm._v(_vm._s(item.partNo)),
                  ]),
                  _c(
                    "td",
                    {
                      staticClass:
                        "has-vertical-middle has-text-centered is-content-width",
                    },
                    [_vm._v(_vm._s(item.subQuoteNo))]
                  ),
                  _c(
                    "td",
                    {
                      staticClass:
                        "has-vertical-middle has-text-centered is-content-width",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "button is-primary is-small is-inverted",
                          on: {
                            click: function ($event) {
                              return _vm.addNewItem(item, index)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon is-medium" }, [
                            _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("span", { attrs: { icon: "icon is-large" } }, [
                      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                    ]),
                    _c("p", [_vm._v("Nothing")]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }